export default __webpack_public_path__ + "static/media/artistBanner4.7445b559.png";